import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { usePetitionShareCounts } from '#src/app/pages/petitionDetails/shared/hooks';

/**
 * True while the momentum bar reserves vertical space: share counts are still loading,
 * or the bar would render real content (same eligibility as MomentumBar component).
 * When false, MomentumBar returns null, so we do not mount scroll-past tracking.
 */
export function useMomentumBarSlotVisible(): boolean {
	const {
		data: {
			petition: { commentsConnection },
			mediaSourcesPage,
		},
	} = usePetitionDetailsPageData();

	const commentsCount = commentsConnection.totalCount || 0;
	const hasMediaMentions = mediaSourcesPage.numberOfMediaSources > 0;

	const { totalShareCount, isLoading: isShareCountsLoading } = usePetitionShareCounts({
		enabled: commentsCount > 0 && !hasMediaMentions,
	});

	if (commentsCount === 0) {
		return false;
	}

	if (hasMediaMentions) {
		return true;
	}

	if (isShareCountsLoading) {
		return true;
	}

	return (totalShareCount ?? 0) > 0;
}
